import React from 'react'
import { WP_REST_API_Post } from 'wp-types/index'
import Category, { CategoryType } from '../../../../components/Category'
import { Color, Direction, Layout } from '../../../../utils/constants'
import Background from '../../../../assets/backgrounds/blog.svg'
import Tag from '../../../../components/Tag'
import PageHeader from '../../../../partials/PageHeader'
import { capitalize, getMonth, Link } from '../../../../utils/helpers'
import Separator from '../../../../components/Separator'
import SectionWithTag from '../../../../components/SectionWithTag'
import parse from 'html-react-parser'
import { twMerge } from 'tailwind-merge'
import ArrowButton from '../../../../components/Button/variations/ArrowButton'
import { FormattedMessage } from 'react-intl'
import SimilarResources from '../SimilarResources'
import FadeIn from '../../../../components/Animation/FadeIn'
import Image from '../../../../components/Image'

interface BlogProps {
  resource: WP_REST_API_Post | null
  category: CategoryType
  tags: string[]
}

const Blog = ({ resource, category, tags }: BlogProps) => {
    const author = resource?._embedded?.author
        .map((auth) => {
            // @ts-ignore
            const name: string = auth?.name
            return name
                .split(' ')
                .map((nameField) => capitalize(nameField))
                .join(' ')
        })
        .join(', ')
    const publicationDate = resource && new Date(resource.date)
    const getImageProps = () => {
    // @ts-ignore
        if (typeof resource?.acf?.featured_image === 'string') {
            // @ts-ignore
            if (isNaN(parseInt(resource?.acf?.featured_image))) {
                // @ts-ignore
                return { src: resource?.acf?.featured_image }
            } else {
                // @ts-ignore
                return { imageId: parseInt(resource?.acf?.featured_image) }
            }
        } else {
            // @ts-ignore
            if (typeof resource?.acf?.featured_image === 'number') {
                // @ts-ignore
                return { imageId: resource?.acf?.featured_image }
            }
        }
    }
    return (
        <div>
            <PageHeader bgColor={Color.SAND} component={Background} className='!pr-0'>
                <div className='flex md:items-end justify-between flex-col md:flex-row'>
                    <div className='max-w-[623px] pb-12 side-padding md:px-0'>
                        <div className='pb-12'>
                            <Link
                                to={`/resources/${category}`}
                                className={twMerge('w-max flex items-center opacity-60 gap-x-6')}
                            >
                                <ArrowButton direction={Direction.LEFT} buttonColor={Color.BLACK} />
                                <div className='flex gap-x-2 items-center'>
                                    <FormattedMessage id='page.resources' tagName='h6' />
                                    <h6>/</h6>
                                    <FormattedMessage id={`page.resources.${category}`} tagName='h6' />
                                </div>
                            </Link>
                        </div>
                        <FadeIn appearFromBottom>
                            <>
                                <Category type={category} className='bg-transparent backdrop-blur-none px-0' />
                                <h3 className='py-8'>{resource?.title?.rendered}</h3>
                                <div className='flex'>
                                    <p>{author}</p>
                                    <Separator direction={Layout.VERTICAL} />
                                    <p>
                                        {getMonth(publicationDate?.getMonth() ?? 0)} {publicationDate?.getFullYear()}
                                    </p>
                                </div>
                            </>
                        </FadeIn>
                    </div>
                    {/*@ts-ignore*/}
                    {resource?.acf?.featured_image && (
                        <div className='md:max-w-[50vw] self-stretch max-h-[33vh] md:max-h-full xl:max-h-[50vh]'>
                            <Image
                                {...getImageProps()}
                                className='object-cover h-full ml-auto'
                                alt={resource?.slug}
                            />
                        </div>
                    )}
                </div>
            </PageHeader>
            <div className='md:py-30 2xl:max-w-screen-2xl mx-auto'>
                {tags.length > 0 && (
                    <div className='md:hidden side-padding py-10'>
                        <h6 className='pb-2'>Tags:</h6>
                        <div className='flex flex-wrap gap-2'>
                            {tags.map((tag) => (
                                <Tag title={tag} color={Color.BLACK} key={tag} />
                            ))}
                        </div>
                    </div>
                )}
                <SectionWithTag tag={{ id: `category.${category}` }}>
                    {resource && (
                        <FadeIn>
                            <div className='flex justify-between items-start py-9'>
                                <div className='max-w-[744px] resource-body'>
                                    {parse(resource.content.rendered)}
                                </div>
                                {tags.length > 0 && (
                                    <div className='max-w-[240px] hidden md:block'>
                                        <h6 className='pb-2'>Tags:</h6>
                                        <div className='flex flex-wrap gap-2'>
                                            {tags.map((tag) => (
                                                <Tag title={tag} color={Color.BLACK} key={tag} />
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </FadeIn>
                    )}
                </SectionWithTag>
            </div>
            <SimilarResources category={category} currentPostId={resource?.id} />
        </div>
    )
}

export default Blog
